//	+-----------------------------------------------+
//	| Charting view objects                         |
//	+-----------------------------------------------+

/**
 * @file charts.js
 * @desc Contains view objects that draw charts in various ways.
 * @author Geoffrey Pursell
 */

define('cardboard/chartViews',[
  // libraries
  "jquery",
  "underscore",
  "underscore.string",
  "jspdf",
  "autotable",
  "rgbcolor",
  "canvg",
  "backbone",
  "highcharts",
  "highcharts-venn",
  "highcharts-export",
  "hogan",
  "bowser",
  // app modules
  "cardboard/baseViews",
  "cardboard/util",
  "cardboard/transforms",
  // dumb loaders
  // "highcharts3scrollfix"
], function (
  $,
  _,
  _s,
  jsPDF,
  autotable,
  rgbcolor,
  canvg,
  Backbone,
  Highcharts,
  HighchartsVenn,
  HighchartsExport,
  Hogan,
  Bowser,
  Views,
  Util,
  Transforms
  /*HCScrollFix */
) {
  console.log("MODULE: cardboard/chartViews");
  (function (H) {
    H.Chart.prototype.createCanvas = function (divId) {
      var svg = this.getSVG(),
        width = parseInt(svg.match(/width="([0-9]+)"/)[1]),
        height = parseInt(svg.match(/height="([0-9]+)"/)[1]),
        canvas = document.createElement("canvas");

      canvas.setAttribute("width", width);
      canvas.setAttribute("height", height);

      if (canvas.getContext && canvas.getContext("2d")) {
        canvg(canvas, svg);

        return canvas.toDataURL("image/jpeg");
      } else {
        alert(
          "Your browser doesn't support this feature, please use a modern browser"
        );
        return false;
      }
    };
  })(Highcharts);

  exportChart = function (chartID) {
    var chartThis, chartTitle, splitText, imgData, text0, text1, text2, text3; //   = charts[chartID.match(/\d+/)[0]];

    for (var j = 0; j < charts.length; j++) {
      if (charts[j].container.id === chartID) {
        chartThis = charts[j];
      }
    }

    if (
      /MSIE\s/.test(navigator.userAgent) &&
      parseFloat(navigator.appVersion.split("MSIE")[1]) < 10
    ) {
      alert("Sorry you need Internet Explorer 10 or above to save as PDF.");
    } else {
      var tables = 0;
      var pdfsize = "letter";

      var doc = new jsPDF("p", "pt", pdfsize);

      // All units are in the set measurement for the document
      // This can be changed to "pt" (points), "mm" (Default), "cm", "in"
      doc.setFontSize(11);
      doc.setFont("helvetica");

      $.each($(".eec"), function (index, value) {
        this.setAttribute("id", "" + tables + "");
        ++tables;
      });

      if (location.host.indexOf("eclds") > -1) {
        chartTitle =
          chartThis.renderTo.parentElement.parentElement.childNodes[5]
            .innerText ||
          chartThis.renderTo.parentElement.parentElement.childNodes[5]
            .textContent;
        imgData =
          "data:image/png;base64,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";
        doc.addImage(imgData, "JPEG", 405, 10, 200, 40);
        text0 = "Minnesota Early Childhood Longitudinal Data System";
      } else {
        imgData =
          "data:image/png;base64,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";
        doc.addImage(imgData, "JPEG", 405, 10, 200, 27);
        text0 = "Minnesota Report Card";
        if (location.hash.indexOf("mySchool") > -1) {
          chartTitle = chartThis.renderTo.parentElement.children[0].innerText;
        } else {
          chartTitle =
            chartThis.renderTo.parentElement.parentElement.childNodes[3]
              .innerText ||
            chartThis.renderTo.parentElement.parentElement.childNodes[3]
              .textContent ||
            chartThis.renderTo.parentElement.parentElement.children[0]
              .textContent;
          if (chartTitle.trim().length < 2)
            chartTitle =
              chartThis.renderTo.parentElement.parentElement.children[0]
                .textContent;
        }
      }

      doc.setFontType("bold");
      doc.text(20, 25, text0);

      doc.setFontSize(9);

      var qBar = $("#questionBar")[0].innerText;
      splitText = doc.splitTextToSize(qBar.trim(), 380);
      doc.text(20, 35, splitText);
      doc.setFontType("normal");
      text1 =
        chartThis.renderTo.parentElement.parentElement.parentElement
          .parentElement.children[1].innerText ||
        chartThis.renderTo.parentElement.parentElement.parentElement
          .parentElement.children[1].textContent;
      if (location.hash.indexOf("mySchool") > -1) {
        text1 =
          chartThis.renderTo.parentElement.parentElement.parentElement
            .parentElement.parentElement.parentElement.children[1].children[1]
            .innerText;
      }

      text1 = text1.trim().replace(/[ ]{2,}/gi, "");
      splitText = doc.splitTextToSize(text1, 400);
      doc.setFontSize(8);
      if (splitText[0].indexOf("search for a school or change settings") < 1) {
        doc.text(20, 60, splitText);
      }
      doc.setFontSize(10);
      chartTitle = chartTitle.replace(/click to collapse contents/gi, "");
      chartTitle = chartTitle.replace(/click to expand contents/gi, "");
      doc.setFontType("bold");
      doc.text(20, 105, chartTitle.trim());
      doc.setFontType("normal");
      doc.setFontSize(8);
      text2 =
        chartThis.renderTo.previousSibling.previousSibling.innerText ||
        chartThis.renderTo.previousSibling.previousSibling.textContent;

      if (
        text2 &&
        text2.length > 4 &&
        chartThis.renderTo.previousSibling.previousSibling.outerHTML.indexOf(
          "<table"
        ) < 1
      ) {
        text2 = text2.replace(/Export to PDF/gi, "");

        if (text2.length < 200) {
          splitText = doc.splitTextToSize(text2.trim(), 600);
          doc.text(20, 117, splitText);
        } else {
          splitText = doc.splitTextToSize(text2.trim(), 225);
          doc.text(375, 130, splitText);
        }
      }

      text3 =
        chartThis.renderTo.previousSibling.innerText ||
        chartThis.renderTo.previousSibling.textContent;

      if (text3) {
        text3 = text3.replace(/Export to PDF/gi, "");

        if (text2.length < 200) {
          splitText = doc.splitTextToSize(text3.trim(), 225);
          doc.text(375, 130, splitText);
        } else {
          splitText = doc.splitTextToSize(text3.trim(), 600);
          doc.text(20, 117, splitText);
        }
      }
      var imageDataIndex;
      if (chartThis.renderTo.nextSibling.children[0]) {
        imageDataIndex = chartThis.renderTo.nextSibling.children[0].id;
      }

      if (location.hash.indexOf("mySchool") > -1) {
        imageDataIndex = chartThis.renderTo.nextSibling.id;
      }
      $(".chartHolder").each(function (index) {
        var imageData = $(this).highcharts().createCanvas();
        //    console.log(index, imageDataIndex);
        if (location.hash.indexOf("northStarProgress") > -1) {
          if ($(this).hasClass("hiddenOffscreen")) imageDataIndex += 1;
        }
        if (index == imageDataIndex) {
        //  console.log(text3);
          doc.addImage(imageData, "JPEG", 20, 145, 350, 240);
          // doc.addImage(imageData, "JPEG", 20, 215, 350, 240);
        }
      });

      var res,
        noChart = false;

      if (location.hash.indexOf("mySchool") > -1) {
        if (chartThis.renderTo.nextSibling.children.length > 1) {
          res = doc.autoTableHtmlToJson(chartThis.renderTo.nextSibling);
        }
      } else if (location.hash.indexOf("assessmentsParticipation") > -1) {
        if (chartThis.renderTo.nextSibling.children.length > 0)
          res = doc.autoTableHtmlToJson(
            document.getElementById(imageDataIndex)
          );
      } else if (
        chartThis.renderTo.nextSibling.innerText ==
        "No ADM Served, no data to display."
      ) {
      } else if (
        chartThis.renderTo.nextSibling.innerText ==
        "The selected criteria resulted in counts too small to report."
      ) {
      } else if (
        chartThis.renderTo.nextSibling.innerText ==
        "No average scale score data available for the selected criteria."
      ) {
      } else if (
        chartThis.renderTo.nextSibling.innerText ==
        "The selected criteria resulted in counts not reported due to additional privacy protection rules."
      ) {
      } else if (
        chartThis.renderTo.nextSibling.innerText ==
        "No Homeless Preschool data available for this organization."
      ) {
      } else if (
        chartThis.renderTo.nextSibling.innerText ==
        "Data is not available for current selection(s)."
      ) {
      } else {
        // The selected criteria resulted in counts too small to report.
        if (chartThis.renderTo.nextSibling.children.length > 0) {
          res = doc.autoTableHtmlToJson(
            chartThis.renderTo.nextSibling.children[0]
          );
        } else if (location.hash.indexOf("northStarProgress") > -1) {
          // Do nothing
        } else if (
          chartThis.renderTo.nextSibling.nextSibling.children.length > 0
        ) {
          res = doc.autoTableHtmlToJson(
            chartThis.renderTo.nextSibling.nextSibling.children[0]
          );
          noChart = true;
        }
      }

      doc.setFontSize(9);

      if (typeof res !== "undefined" && res.data[0].length > 1) {
        //res.columns[2] = "Compared to organizations with high population <br/> of students of color and American Indian";
        doc.autoTable(res.columns, res.data, {
          // startY: doc.autoTableEndPosY() + 40,
          startY: 385,
          margin: 20,

          tableWidth: "wrap", // 'auto', 'wrap' or a number,
          theme: "plain",
          styles: {
            cellWidth: "wrap",
            overflow: "linebreak",
            fontSize: 7,
            rowHeight: 12,
            columnWidth: "wrap",
          },
          headerStyles: {
            overflow: "linebreak",
            fontSize: 7,
            rowHeight: 12,
            columnWidth: "wrap",
          },
          columnStyles: {
            0: {columnWidth : 'auto'},
            1: {columnWidth : 'auto'},
            2: {columnWidth : 'auto'},
            3: {columnWidth : 'auto'},
            4: {columnWidth : 'auto'},
            5: {columnWidth : 'auto'},
            6: {columnWidth : 'auto'}
          },

        });
      } else {
        doc.text(20, 125, chartThis.renderTo.nextSibling.innerText);
      }

      if (noChart) {
        doc.text(20, 125, chartThis.renderTo.nextSibling.innerText);
      }

      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var date =
        (("" + month).length < 2 ? "0" : "") +
        month +
        "/" +
        (("" + day).length < 2 ? "0" : "") +
        day +
        "/" +
        d.getFullYear();

      doc.setFontSize(7);

      var tempString = text0 + ". (n.d.) ";
      //   doc.setFontType("italic");
      tempString +=
        chartTitle.trim() +
        " " +
        (chartThis.renderTo.parentElement.parentElement.parentElement
          .parentElement.children[0].innerText ||
          chartThis.renderTo.parentElement.parentElement.parentElement
            .parentElement.children[0].textContent);

      tempString = tempString.replace(
        "Select to search for a school or change settings",
        ""
      );
      tempString = tempString.replace(/\s+/g, " ").trim();
      var pUrl = "" + window.location + "";
      pUrl = pUrl.replace(/.*?:\/\//g, "");
      tempString += " \n Retrieved " + date + " from " + pUrl;
      tempString = doc.splitTextToSize(tempString, 500);

      // doc.text(20, 670, tempString);
      var y = 743;

      for (j = 0; j < tempString.length; j++) {
        doc.myText(
          tempString[j],
          {
            align: "center",
          },
          0,
          y
        );
        y += 13;
      }

      var isiPad = navigator.userAgent.match(/iPad/i) != null;
      setTimeout(function () {
        if (
          isiPad ||
          (navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1)
        ) {
          //    var string = doc.output('datauristring');
          var string = doc.output("datauri");

          var x = window.open();
          x.document.open();
          x.document.location = string;
          //  x.window.close();
        } else {
          doc.save("export.pdf");
        }
      }, 1500);
      if (location.host.indexOf("eclds") > -1) {
        window.workspace.setModalInfoDialogContent(
          "<form id='feedback'><p>We like to know what you're finding useful in the system that we've built based on previous users' feedback. We also use this with our funders who are making decisions on long-term funding.</p><fieldset class='group'><legend style='font-size: 17px; font-weight: bold; padding-bottom: 4px;'>Are you using the system for <br/>(check as many as apply):</legend><div class='checkbox'><input id='resRep' type='checkbox' name='resRep' value='Yes' /><label class='notBold inline' for='resRep'>Research/reports</label></div> <div class='checkbox'><input id='commAssess' type='checkbox' name='commAssess' value='Yes' /><label class='notBold inline' for='commAssess'>Community assessments</label></div><div class='checkbox'><input id='fund' type='checkbox' name='fund' value='Yes' /><label class='notBold inline' for='fund'>Funding and/or fund raising</label></div> <div class='checkbox'><input id='exploration' type='checkbox' name='exploration' value='Yes' /><label class='notBold inline' for='exploration'>Exploration or school assignments</label></div><div class='checkbox'><input id='other' type='checkbox' name='other' value='Yes' /><label class='notBold inline' for='other'>Other (fill in)</label> <input id='otherText' type='text' name='otherText' /></div></fieldset><br/><label><strong>Is there anything else you would like us to know?</strong><br/><textarea rows='1' cols='1' size='80' name='feedbackText' style='height: 8.9em; width: 330px'></textarea><p><a href='#questionBar' data-rel='back'>No thanks, Close Window</a> <input type='hidden' name='url'  value='" +
            window.location.href +
            "'>&nbsp;&nbsp;&nbsp;<input id='subFeedback' type='submit' value='Submit'> </p></form>"
        );
        Backbone.trigger("modalOpened");
        window.workspace.showModalInfoDialog();

        $("#feedback").submit(function () {
          // tasks to do
          var formdata = $(this).serialize();

          $.ajax({
            type: "POST",
            url: "https://education.mn.gov/poll/send_ecldsFeedback_email2.php",
            data: formdata,
          });
          window.workspace.setModalInfoDialogContent(
            "<p> Thank you, your feedback has been submitted.</p><br/><a href='#questionBar' data-rel='back'> Close Window</a> "
          );

          return false;
        });
      }
    }
  };

  /**
   * Contains view objects that draw charts in various ways.
   * @exports cardboard/charts
   */
  var Charts = {};
  var gradIndex = 100; //Used for defining gradient definitions in SVG chars. Prevents duplication.
  /**
   * @namespace
   */
  Charts.ChartProviders = {};
  window.charts = [];
  window.tableSave = [];
  window.chartSave = [];
  window.chartHeadSave = [];
  window.tableSave2 = [];
  window.chartSave2 = [];
  window.chartHeadSave2 = [];
  window.tableSave2 = [];
  window.chartSave2 = [];
  window.chartHeadSave2 = [];
  window.count = -1;
  window.chartCount = 0;

  /**
   * @class
   * @classdesc Use HighCharts to make charts.
   * @param view a reference to the view object requesting this provider
   */

  // constructor-function pattern used for some stuff because it
  // depends on runtime data
  Charts.ChartProviders.Highcharts = function (view) {
    // init the chartprovider object

    var vo = view.options,
      vi = vo.viewInfo;
 //   console.log(vo);
    /**
     * the view object that created this ChartProvider instance
     */
    this.view = view;

    /** this is where we'll put the instantiated HC object */
    this.obj = null;

    /**
     * BASE CONFIG OBJECT.
     * this needs to get done here rather than in the prototype
     * because we want each instance to have its own copy.
     *
     * this takes our abstracted chart config and uses it to produce
     * a HighCharts-specific config
     *
     * parts of this get set up at render time rather than init time.
     */

    this.config = {
      credits: {
        enabled: false,
      },
      colors: Util.Color.colorArrayForChartType(vo.type),
      //  title: vi.title,
      title: {
        text: vi.title,
      },
      lineData: vi.lineData,
      lineSpan: vi.lineSpan,
      chart: {
        backgroundColor: "#FCFFC5",
      },
      xAxis: {
        // If categories are present for the xAxis, names are
        // used instead of numbers for that axis. Since
        // Highcharts 3.0, categories can also be extracted by
        // giving each point a name and setting axis type to
        // "category".
        type: "category",
        labels: {
          enabled: vi.xAxisLabel === false ? false : true,
          style: {
            fontSize: "9px",
          },
        },
      },
      lang: {
        thousandsSep: ",",
      },
      yAxis: {
        min: vi.yAxisMin || 0,
        max: vi.yAxisMax || 100,
        type: vi.yAxisType || "linear",
        // max: calculated dynamically, below
        maxPadding: 0,
        labels: {
          format:
            (vi.unitPreString === "$" ? "$" : "") +
            "{value:,.0f}" +
            vi.unitString,
        },
        title: {
          text: vi.yLabel || null,
        },
        reversedStacks: vi.reversedStacks === false ? false : true,
        gridLineDashStyle: "Dash",
        stackLabels: {
          enabled: vi.stackLabels === false ? false : true,
          formatter: function () {
            if (
              _.isNull(this.total) ||
              _.isUndefined(this.total) ||
              this.total === 0.0
            ) {
              return "";
            }

            return this.total.toFixed(1) + vi.unitString;
          },
        },
        minorTickInterval: vi.minorTickInterval || null,
        minorGridLineColor: vi.minorGridLineColor || null,
      },
      legend: {
        backgroundColor: vo.legendBackgroundColor,
        borderWidth: 0,
        enabled: vi.showLegend, // took out || vo.type !== "column"
        reversed: !!vi.legendReversed,
        itemStyle: {
          fontWeight: "normal",
          fontSize: "11px",
        },
      },
      tooltip: {
        valueSuffix: vi.unitString,
      },
      plotOptions: {
        series: {
          stacking: _s.startsWith(vo.type, "stacked") ? "normal" : null,
          pointWidth: vi.pointWidth || null,
        },
        bar: {
          dataLabels: {
            enabled: vi.dataLabels === true ? true : false,
            format: "{point.allInfo.percentDisplay}",
          },
        },
        line: {
          connectNulls: true,
          dataLabels: {
            enabled: false,
            overflow: "none",
            crop: false,
            format: "{point.y:.1f}" + vi.unitString,
            color: "#000",
            borderRadius: 5,
            y: -3,
            padding: 0,
          },
        },
        column: {
          // if there's more than one series, it's a grouped column
          // chart.
          // WARNING: this is faulty assumption about
          // colorByPoint. there could be a grouped column chart with
          // one repeating series.
          colorByPoint:
            vo.type === "column" &&
            !_.isUndefined(vi.colorByPoint) &&
            vi.colorByPoint,
          pointPadding: 0,
          /*  events: {
                                          ((vi.disableLegendClick === true) ? legendItemClick: function () {
                                              return true;
                                          } : false)
                                      },*/
          events: {
            legendItemClick: function () {
              if (vi.disableLegendClick) {
                return false;
              }
            },
            select: function () {
              if (vi.disableLegendClick) {
                return false;
              }
            },
          },
          dataLabels: {
            enabled: vi.dataLabels === true ? true : false,

            y: -1,
            formatter: function () {
              if (
                vi.type === "stackedColumn" &&
                (this.y <= 7 || $(document).outerWidth() < 350)
              ) {
                return null;
              }

              if (vi.dataLabels2 === true) return this.point.allInfo.ctstr;
              else
                return (
                  (vi.unitPreString === "$" ? "$" : "") +
                  Highcharts.numberFormat(
                    this.y,
                    !_.isUndefined(vi.unitDec) ? vi.unitDec : 0,
                    ".",
                    ","
                  ) +
                  vi.unitString
                );
            },
            color: vi.type === "stackedColumn" ? "#ffffff" : "#000000",
            style: {
              textShadow:
                "1px 1px 1px " +
                (vi.type === "stackedColumn" ? "#000000" : "#ffffff"),
              fontSize: vi.type === "stackedColumn" ? "24px" : "24px", // ,
              // opacity: "0.8"
              fontWeight: "bold",
            },
          },
          cursor: "pointer",
          point: {
            events: {
              click: function () {
                var drilldown;
                var whichChart =
                  this.series.chart.container.parentElement.parentElement
                    .parentElement.children[2].innerText;

                if (this.allInfo.drillParm) {
                  drilldown = this.allInfo.drillParm;

                  if (whichChart.indexOf("Economic Assistance") > -1) {
                    drill2(drilldown, this.series.chart.container.id, "");
                  } else if (
                    whichChart.indexOf("Scholarship Participation") > -1
                  ) {
                    drill3(drilldown, this.series.chart.container.id, "");
                  } else {
                    drill(drilldown, this.series.chart.container.id, "");
                  }
                }
              },
            },
          },
        },
        pie: {
          allowPointSelect: vi.disableLegendClick ? false : true,

          point: {
            /*events : {
                                                legendItemClick: function(e){
                                                    e.preventDefault();
                                                }
                                            }*/
            events: {
              legendItemClick: function () {
                if (vi.disableLegendClick) {
                  return false;
                }
              },
              select: function () {
                if (vi.disableLegendClick) {
                  //       color: 'null'
                  return false;
                }
              },
            },
          },
          dataLabels: {
            //enabled: false,
            enabled: vi.dataLabels === false ? false : true,
            // format: "<b>{point.name}</b>: {point.percentage:.1f}%"
            format: vi.dataLabelFormat ? vi.dataLabelFormat : null,
          },
          states: {
            hover: {
              enabled: true,
              halo: {
                size: 0,
              },
            },
          },
          showInLegend: vi.showInLegend,
        },
        venn: {
          showInLegend: false,
          legendGroup: {
            onmouseover: null,
          },
          point: {
            events: {
              mouseOver: function () {
                this.state = "hover"; // Hack to work with Highchart v4.0.4
                this.graphic.attr({
                  opacity: 0.5,
                  stroke: "#fff",
                  "stroke-width": 2,
                });
              },
              mouseOut: function () {
                this.state = ""; // Hack to work with Highchart v4.0.4
                this.graphic.attr({
                  opacity: 1,
                  "stroke-width": 0,
                });
              },
            },
          },
          dataLabels: {
            enabled: true,
            // format: "<b>{point.name}</b>: {point.percentage:.1f}%"
            //format: (vi.dataLabelFormat ? vi.dataLabelFormat : null)
          },
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        spline: {
          dataLabels: {
            enable: false,
          },
        },
      },
      navigation: {
        buttonOptions: {},
        menuItemStyle: {
          padding: "6px 8px",
        },
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: vi.hideContext === true ? false : true,
            x: 16,
            y: -10,
          },
          contextButton2: {
            enabled: vi.exportToPDF === true ? false : false,
            x: 14,
            y: -5,
            symbol: "url(/cardboard/images/hamb_menu.png)",

            menuItems: [
              {
                text: "Export to PDF",
                onclick: function () {
                  if (
                    /MSIE\s/.test(navigator.userAgent) &&
                    parseFloat(navigator.appVersion.split("MSIE")[1]) < 10
                  ) {
                    alert(
                      "Sorry you need Internet Explorer 10 or above to save as PDF."
                    );
                  } else {
                    var tables = 0;
                    var pdfsize = "letter";

                    var doc = new jsPDF("p", "pt", pdfsize);

                    // All units are in the set measurement for the document
                    // This can be changed to "pt" (points), "mm" (Default), "cm", "in"
                    doc.setFontSize(11);
                    doc.setFont("helvetica");

                    $("table").each(function () {
                      this.id = "" + tables++ + "";
                    });

                    var splitText;

                    //Add Logo
                    var imgData =
                      "data:image/png;base64,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";

                    doc.addImage(imgData, "JPEG", 395, 10, 210, 55);
                    doc.setFontType("bold");

                    var text0 =
                      "Minnesota Early Childhood Longitudinal Data System";

                    var text1 =
                      this.renderTo.parentElement.parentElement.parentElement
                        .parentElement.children[0].innerText ||
                      this.renderTo.parentElement.parentElement.parentElement
                        .parentElement.children[0].textContent;
                    doc.text(20, 30, text0);

                    doc.setFontType("normal");

                    text1 = text1.trim().replace(/[ ]{2,}/gi, "");
                    splitText = doc.splitTextToSize(text1, 400);
                    doc.text(20, 55, splitText);

                    var chartTitle =
                      this.renderTo.parentElement.parentElement.childNodes[5]
                        .innerText ||
                      this.renderTo.parentElement.parentElement.childNodes[5]
                        .textContent;

                    chartTitle = chartTitle.replace(
                      /click to collapse contents/gi,
                      ""
                    );
                    chartTitle = chartTitle.replace(
                      /click to expand contents/gi,
                      ""
                    );
                    doc.setFontType("bold");
                    doc.text(20, 95, chartTitle.trim());
                    doc.setFontType("normal");
                    var text2 =
                      this.renderTo.previousSibling.previousSibling.innerText ||
                      this.renderTo.previousSibling.previousSibling.textContent;

                    if (text2) {
                      splitText = doc.splitTextToSize(text2.trim(), 500);
                      doc.text(20, 110, splitText);
                    }

                    var text3 =
                      this.renderTo.previousSibling.innerText ||
                      this.renderTo.previousSibling.textContent;

                    if (text3) {
                      splitText = doc.splitTextToSize(text3.trim(), 500);
                      doc.text(20, 140, splitText);
                    }

                    // add image to doc, if you have lots of charts,
                    // you will need to check if you have gone bigger
                    // than a page and do doc.addPage() before adding
                    // another image.

                    /**
                     * addImage(imagedata, type, x, y, width, height)
                     */
                    var imageDataIndex =
                      this.renderTo.nextSibling.childNodes[0].id;
                    $(".chartHolder").each(function (index) {
                      var imageData = $(this).highcharts().createCanvas();

                      // add image to doc, if you have lots of charts,
                      // you will need to check if you have gone bigger
                      // than a page and do doc.addPage() before adding
                      // another image.

                      /**  * addImage(imagedata, type, x, y, width, height)  */

                      if (index == imageDataIndex) {
                        doc.addImage(imageData, "JPEG", 20, 200, 350, 240);
                      }
                    });

                    var res = doc.autoTableHtmlToJson(
                      document.getElementById(imageDataIndex)
                    );

                    doc.autoTable(res.columns, res.data, {
                      // startY: doc.autoTableEndPosY() + 40,
                      startY: 470,
                      margin: 20,

                      tableWidth: "auto", // 'auto', 'wrap' or a number,
                      theme: "plain",
                      styles: {
                        overflow: "linebreak",
                        fontSize: 7,
                        rowHeight: 15,
                        columnWidth: "wrap",
                      },
                      headerStyles: {
                        fontSize: 8,
                      },
                    });

                    var d = new Date();

                    var month = d.getMonth() + 1;
                    var day = d.getDate();

                    var date =
                      (("" + month).length < 2 ? "0" : "") +
                      month +
                      "/" +
                      (("" + day).length < 2 ? "0" : "") +
                      day +
                      "/" +
                      d.getFullYear();

                    doc.setFontSize(8);

                    var tempString =
                      "Early Childhood Longitudinal Data System. (n.d.) ";
                    //   doc.setFontType("italic");
                    tempString +=
                      chartTitle.trim() +
                      " " +
                      (this.renderTo.parentElement.parentElement.parentElement
                        .parentElement.children[0].innerText ||
                        this.renderTo.parentElement.parentElement.parentElement
                          .parentElement.children[0].textContent);
                    tempString = tempString.replace(/\s+/g, " ").trim();
                    var pUrl = "" + window.location + "";
                    pUrl = pUrl.replace(/.*?:\/\//g, "");
                    tempString += " \n Retrieved " + date + " from " + pUrl;
                    tempString = doc.splitTextToSize(tempString, 500);

                    // doc.text(20, 670, tempString);
                    var y = 670;

                    for (var j = 0; j < tempString.length; j++) {
                      doc.myText(
                        tempString[j],
                        {
                          align: "center",
                        },
                        0,
                        y
                      );
                      y += 20;
                    }

                    var isiPad = navigator.userAgent.match(/iPad/i) != null;
                    setTimeout(function () {
                      if (
                        isiPad ||
                        (navigator.userAgent.indexOf("Safari") != -1 &&
                          navigator.userAgent.indexOf("Chrome") == -1)
                      ) {
                        //    var string = doc.output('datauristring');
                        var string = doc.output("datauri");

                        var x = window.open();
                        x.document.open();
                        x.document.location = string;
                        //  x.window.close();
                      } else {
                        doc.save("export.pdf");
                      }
                    }, 1500);

                    window.workspace.setModalInfoDialogContent(
                      "<form id='feedback'><p>We like to know what you're finding useful in the system that we've built based on previous users' feedback. We also use this with our funders who are making decisions on long-term funding.</p><fieldset class='group'><legend style='font-size: 17px; font-weight: bold; padding-bottom: 4px;'>Are you using the system for <br/>(check as many as apply):</legend><div class='checkbox'><input id='resRep' type='checkbox' name='resRep' value='Yes' /><label class='notBold inline' for='resRep'>Research/reports</label></div> <div class='checkbox'><input id='commAssess' type='checkbox' name='commAssess' value='Yes' /><label class='notBold inline' for='commAssess'>Community assessments</label></div><div class='checkbox'><input id='fund' type='checkbox' name='fund' value='Yes' /><label class='notBold inline' for='fund'>Funding and/or fund raising</label></div> <div class='checkbox'><input id='exploration' type='checkbox' name='exploration' value='Yes' /><label class='notBold inline' for='exploration'>Exploration or school assignments</label></div><div class='checkbox'><input id='other' type='checkbox' name='other' value='Yes' /><label class='notBold inline' for='other'>Other (fill in)</label> <input id='otherText' type='text' name='otherText' /></div></fieldset><br/><label><strong>Is there anything else you would like us to know?</strong><br/><textarea rows='1' cols='1' size='80' name='feedbackText' style='height: 8.9em; width: 330px'></textarea><p><a href='#questionBar' data-rel='back'>No thanks, Close Window</a> <input type='hidden' name='url'  value='" +
                        window.location.href +
                        "'>&nbsp;&nbsp;&nbsp;<input id='subFeedback' type='submit' value='Submit'> </p></form>"
                    );
                    Backbone.trigger("modalOpened");
                    window.workspace.showModalInfoDialog();

                    $("#feedback").submit(function () {
                      // tasks to do
                      var formdata = $(this).serialize();

                      $.ajax({
                        type: "POST",
                        url: "https://education.mn.gov/poll/send_ecldsFeedback_email2.php",
                        data: formdata,
                      });
                      window.workspace.setModalInfoDialogContent(
                        "<p> Thank you, your feedback has been submitted.</p><br/><a href='#questionBar' data-rel='back'> Close Window</a> "
                      );

                      return false;
                    });
                  }
                },
                separator: false,
              },
            ],
          },
        },
      },
    };

    // maybe do a custom tooltip!
    // let's have different default for some chart types, and also load up a
    // mustache template if it's present in the view info object
    if (_.isString(vi.tooltipTemplate)) {
      if (!this.config.tooltip) {
        this.config.tooltip = {};
      }
      $.extend(this.config.tooltip, {
        formatter: function () {
          var environment = _.extend(this.point.allInfo, {
            seriesName: this.series.name,
          });

          var html = Hogan.compile(vi.tooltipTemplate).render(environment),
            breakPointText = this.point.allInfo.trendDataPointMessage;

          // if this point is a known break point, we need to display
          // a special warning message.
          if (breakPointText) {
            html += "<span class='warning'>" + breakPointText + "</span>";
          }

          //Since I can't access slice from SLEDS New Student Demographics - New Enrollment by Demographic I will do manually when REPLACE is encountered.
          if (html == "REPLACE") {
            html =
              environment.slice[this.series.index].name +
              ": <b>" +
              environment.slice[this.series.index].formattedPercent +
              "</b>";
          } else if (html == "ROUND") {
            html =
              this.point.series.name +
              "<br/>" +
              this.point.name +
              ": <b>" +
              Math.round(this.point.y) +
              vi.unitString +
              "</b>";
          } else if (html == "ROUND2") {
            html =
              this.point.series.name +
              "<br/>" +
              this.point.name +
              ": <b>" +
              Math.round(this.point.y * 10) / 10 +
              vi.unitString +
              "</b>";
          }
          return html;
        },
        useHTML: true,
      });
    } else if (
      vo.type === "pie" ||
      vo.type === "bar" ||
      vi.type === "stackedColumn" ||
      (vo.type === "column" && vi.series.length < 3) ||
      vi.unitPreString === "$"
    ) {
      $.extend(this.config.tooltip, {
        formatter: function () {
          return (
            (this.point.longName || this.point.name) +
            (vi.hoverSeriesName === "Y" ? "<br/>" + this.point.series.name  : "")  +
           
            ":" +
            " <b>" +
            (vi.unitPreString === "$" ? "$" : "") +
            Highcharts.numberFormat(
              this.point.y,
              !_.isUndefined(vi.unitDec) ? vi.unitDec : 0,
              ".",
              ","
            ) +
            vi.unitString +
            "</b>"
          );
        },
      });
    }
  };

  // HighCharts provider object methods and default properties

  Charts.ChartProviders.Highcharts.prototype = {
    _markBreakPoints: function (chartableData) {
      try {
        _(chartableData).each(function (series) {
          _(series.data).each(function (point) {
            if (point.allInfo.trendDataPointMessage) {
              // Most can handle this being an SVG; IE can't
              point.marker = {
                symbol:
                  "url(/cardboard/images/warningMarker" +
                  (Bowser.msie ? ".png)" : ".svg)"),
              };
            }
          });
        });
      } catch (err) {
        console.log("error marking breakpoints.");
      }
    },

    /**
     * read the data series from the model object and produce the format
     * that HighCharts expects. Just like the generic adaptDataForCharting()
     * in Transforms, only this one knows what params to pass, and how to
     * mark breakpoints
     */
    adaptDataForCharting: function () {
      // this.view is a reference to the ChartView that built
      // this ChartProvider
      var vi = this.view.options.viewInfo,
        dataView = this.view.model.getCleanDataView(vi),
        chartableSeries;

      this._warnAboutNonArrayData(dataView);
      chartableSeries = Transforms.adaptDataForCharting(dataView, vi);

      // this can only be done when there's a real view object involved,
      // since only it knows about filter selections, which are necessary
      // to mark breakpoints
      this._markBreakPoints(chartableSeries, this.view);

      return chartableSeries;
    },
    _warnAboutNonArrayData: function (dataView) {
      if (!dataView) {
        return;
      }

      var vi = this.view.options.viewInfo,
        chartableData = dataView.data;

      if (
        _.isObject(chartableData) &&
        !_.isArray(chartableData) &&
        !_(vi.series).any(seriesHasDataPath) &&
        !_(vi.series).any(seriesHasManualValues)
      ) {
        console.log(
          "WARNING: The data for " +
            this.identifyChart() +
            " is not an array. Consider setting convertDataHashToArray: true in your view."
        );
        console.log("The data is:");
        console.log(chartableData);
      }
    },

    identifyChart: function () {
      var vi = this.view.options.viewInfo;
      return (
        vi.type +
        ' chart with dataSourceName "' +
        vi.dataSourceName +
        (vi.dataPath ? '" and dataPath "' + vi.dataPath : '"')
      );
    },

    /** render the chart */
    plotData: function (options) {
      var chartableSeries = this.adaptDataForCharting(),
        animationSetting;

      // hide loading message
      this.obj.hideLoading();
      if (chartableSeries !== null) {
        if (chartableSeries.length === 0) {
          console.log(
            "WARNING from ChartProvider.plotData: no chartable series for " +
              this.identifyChart()
          );
        }
      }

      // adjust dataLabels
      if (this.view.options.type === "line") {
        this.configureDataLabelsForSeries(chartableSeries);
        this.adjustDataLabels(chartableSeries);
      }

      // add each series to the chart, trying *extra hard* to respect the
      // requested animation boolean
      _(chartableSeries).each(
        function (series) {
          if (options.animate === false) {
            series = _.extend(series, {
              animation: false,
            });
          }

          if (
            series.data[0].allInfo.hasOwnProperty("diaplayInChart") &&
            !series.data[0].allInfo.diaplayInChart
          ) {
            series.data.shift();
          }
          if (
            series.data[0].allInfo.hasOwnProperty("diaplayInChart") &&
            !series.data[0].allInfo.diaplayInChart
          ) {
            series.data.shift();
          }
          this.obj.addSeries(series, false, options.animate);
        }.bind(this)
      );

      // draw the chart -- fence in this call and manage the chart's
      // animation setting
      //  if (options.animate === false) {
      animationSetting = this.obj.animation;
      this.obj.animation = false;
      //    }
      this.obj.redraw();

      // if (this.view.options.viewInfo.dataSetPath == 'dataSets.earlyEducationAndCare') {
      charts[++count] = this.obj;

      //}

      if (this.obj.chartWidth > this.obj.containerWidth) {
        var that = this;
        setTimeout(function () {
          $(window).trigger("resize");
        }, 2000);
      }

      if (this.view.options.type == "venn") {
        var chartSvg = this.obj.renderer.box;
        var availabileDefs = this._forceGradientDefinitions(chartSvg);
        this._customVennLegend(
          this.obj.renderer,
          this.view.options.viewInfo,
          availabileDefs
        );

        $(chartSvg)
          .find(
            ".highcharts-series-group circle, .highcharts-series-group path"
          )
          .each(function (i, el) {
            $(el)
              .attr(
                "fill",
                "url(" +
                  window.location.origin +
                  "/#highcharts-" +
                  availabileDefs[i] +
                  ")"
              )
              .attr("opacity", 1);
          });
      }

      if (options.animate) {
        this.obj.animation = animationSetting;
      }
    },

    _forceGradientDefinitions: function (svgBox) {
      var colors = Util.Color.colorArrayForChartType("pie"),
        $defs = $(svgBox).find("defs");

      var availabileDefs = [];
      _(colors).each(function (v, k) {
        if (_.isObject(v)) {
          createGradient(svgBox, "highcharts-" + gradIndex, v.stops);
          availabileDefs.push(gradIndex);
          gradIndex++;
        }
      });

      function createGradient(svg, id, stops) {
        var svgNS = svg.namespaceURI;
        var grad = document.createElementNS(svgNS, "linearGradient");
        grad.setAttribute("id", id);
        for (var i = 0; i < stops.length; i++) {
          var attrs = stops[i];
          var stop = document.createElementNS(svgNS, "stop");
          stop.setAttribute("offset", attrs[0]);
          stop.setAttribute("stop-color", attrs[1]);
          stop.setAttribute("stop-opacity", 0.85);
          grad.appendChild(stop);
        }

        var defs =
          svg.querySelector("defs") ||
          svg.insertBefore(
            document.createElementNS(svgNS, "defs"),
            svg.firstChild
          );
        return defs.appendChild(grad);
      }

      return availabileDefs;
    },

    _customVennLegend: function (renderer, viewOptions, gradients) {
      var legendLabels = []; // Get the circle labels
      var chartInfo = Util.Data.getDataFromPath(
        this.view.getEnvironment().data,
        viewOptions.dataPath
      );
      for (var i = 0; i < viewOptions.series.length; i++) {
        legendLabels.push(
          Util.Data.getDataFromPath(chartInfo, viewOptions.series[i].dataPath)[
            i
          ].label
        );
      }
      var lx = 30,
        ly = 210,
        lastElBox = {},
        curRow = 0,
        rowMax = 270;
      for (var q = 0; q < legendLabels.length; q++) {
        lastElBox = createLegendItem(q, legendLabels[q], lx, ly);
        curRow += lastElBox.width;
        lx += lastElBox.width + 10;
      }

      function createLegendItem(index, lText, ex, ey) {
        var textEL = createGroup(index, lText, ex, ey);
        var textELBounds = textEL.getBBox();
        if (curRow + textELBounds.width > rowMax) {
          textEL.destroy();
          lx = 30;
          ly += 15;
          curRow = 0;
          textEL = createGroup(index, lText, lx, ly);
          return textEL.getBBox();
        }
        return textELBounds;
      }

      function createGroup(index, lText, ex, ey) {
        var group = renderer.g().add();
        group.attr({
          id: "legendGroup-" + index,
        });
        renderer
          .rect(ex, ey, 16, 12)
          .attr(
            "fill",
            "url(" +
              window.location.origin +
              "/#highcharts-" +
              gradients[index] +
              ")"
          )
          .add(group); //width=16 height=12
        var textEL = renderer.text(lText, ex + 20, ey + 10).add(group);
        return group;
      }
    },

    /** set the requested data label visibility and color data labels based on line color. */
    configureDataLabelsForSeries: function (allSeries) {
      function shouldShowLabels(series) {
        var sl = series.config.showDataLabels;
        if (
          (sl === "whenAlone" && allSeries.length === 1) ||
          (sl === "twoSeriesOrLess" && allSeries.length <= 2) ||
          sl === "always" ||
          sl === true
        ) {
          return true;
        }
        return false;
      }

      // set data label colors and visibility
      _(allSeries).each(function (series) {
        series.dataLabels = {
          color: series.color,
          enabled: shouldShowLabels(series),
        };
      });
    },

    /** A utility for Compare and adjusting data labels based on proximity to
     * other nearby data labels. This is built using an adaptation of the
     * constructor function and module patterns.
     */
    adjustDataLabels: function (allSeries) {
      // safety checks
      if (!(allSeries && allSeries[0])) {
        console.log("bad series fed into the adjuster");
        return;
      }
      // if we only have one series, we have no more to do
      if (allSeries.length < 2) {
        return;
      }

      // WARNING: this proximity threshold is denominated in the units of
      // the graph's y-axis, which in RC are almost all percentages, but
      // the farther we get from that, the more incorrect this will
      // be. What we really need is to calculate distanc in pixels, but
      // this will have to do for now. It's a heuristic, don't ya know.
      var proximityThreshold = 14,
        xRange = _.range(allSeries[0].data.length),
        labelBelowConfig = {
          verticalAlign: "top",
          y: 3,
          // backgroundColor: "rgba(255, 255, 255, 0.7)",
          zIndex: 5,
        },
        labelAboveConfig = {
          verticalAlign: "bottom", // ,
          // backgroundColor: "rgba(255, 255, 255, 0.7)"
        };

      // UTILITY FUNCTIONS

      function getPointStack(xPos) {
        var pointStack = [];

        _(allSeries).each(function (series) {
          var point = series.data[xPos];
          if (point) {
            pointStack.push(point);
          }
        });

        // sort the array so we know which one's on top, which one's on
        // the bottom, and which are in the middle, then return
        return _(pointStack).sortBy("y").value();
      }

      // loop over each X-axis position
      function adjustMiddlePoints(xPos, pointStack) {
        var middleIndices = _.range(1, pointStack.length - 1);

        _(middleIndices).each(function (index) {
          var lowerPoint = pointStack[index - 1],
            thisPoint = pointStack[index],
            higherPoint = pointStack[index + 1];

          // if there's room above, let's put it there
          if (higherPoint.y - thisPoint.y > proximityThreshold) {
            thisPoint.dataLabels = labelAboveConfig;
          }
          // there isn't? maybe there's room below it
          else if (thisPoint.y - lowerPoint.y > proximityThreshold) {
            thisPoint.dataLabels = labelBelowConfig;
          }
          // nuts, there isn't room there either? put it off to the
          // side, I guess
          else {
            thisPoint.dataLabels = {
              verticalAlign: "middle",
              align: xPos === 0 ? "right" : "left",
              x: xPos === 0 ? -10 : 10,
              y: 0,
              style: {
                textShadow: "0px 0px 3px white",
              },
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            };
          }
        });
      }

      function adjustLowestPoint(lowest) {
        if (lowest.y < proximityThreshold) {
          lowest.dataLabels = labelAboveConfig;
        } else {
          lowest.dataLabels = labelBelowConfig;
        }
      }

      // MAIN LOOP

      _(xRange).each(function (xPos) {
        // push a reference to each point in this x position into an
        // array
        var pointStack = getPointStack(xPos),
          lowest,
          highest;

        // lop off the highest and lowest, leaving the middle points in
        // the array
        lowest = pointStack[0]; // lowest is the first element
        highest = pointStack[pointStack.length - 1]; // highest is the last

        // lower point should have label below it;
        // chart default is OK for the highest.
        adjustLowestPoint(lowest);

        // the rest are middle ones, here it gets complicated
        if (allSeries.length > 2) {
          adjustMiddlePoints(xPos, pointStack);
        }
      });
    },

    getChartConfig: function () {
      var standardType = this.view.options.type,
        vi = this.view.options.viewInfo,
        extraConfig = {
          series: [],
          chart: {
            renderTo: this.view.el,
            spacingLeft: 0,
            spacingRight: 15,
            spacingBottom: 5,
            // top spacing extended to 7 to avoid cutting off tops
            // of markers, then to 8 to avoid an IE11 bug in which
            // the top of the y-axis labels were cut off
            spacingTop: 8,
            backgroundColor: "#FFF",
            type: function () {
              // map our internal types to highcharts types
              if (standardType === "stackedColumn") {
                return "column";
              } else if (standardType === "stackedBar") {
                return "bar";
              } else {
                return standardType;
              }
            }.bind(this)(),
            // zoomType: (standardType === "line" ? "xy" : null)
          },
        },
        highChartsConfig = _.extend(this.config, extraConfig);

      // dynamic properties that must be updated at plot time rather than
      // first render time

      // MMR plugin needs to calculate this value itself. Also, if the
      // plugin has a null yAxisMax, we want to pass that through, that
      // means auto-max.
      highChartsConfig.yAxis.max = this.getYAxisMax();

      highChartsConfig.yAxis.tickInterval =
        vi.yAxisTickInterval === null
          ? null
          : this.valueOf(vi.yAxisTickInterval || null);

      // other patches to the config
      // highChartsConfig.plotOptions.series.animation = !this.view.$el.closest(".dataBox").is(".drawerOpen");
      return highChartsConfig;
    },

    getYAxisMax: function () {
      var vi = this.view.options.viewInfo;

      if (vi.yAxisMax) {
        return this.valueOf(vi.yAxisMax);
      } else if (vi.yAxisMaxPath) {
        return Util.Data.getDataFromPath(
          this.view.getEnvironment().data,
          vi.yAxisMaxPath
        );
      } else {
        return 100;
      }
    },

    /** if the value is a function, execute it and pass it a data
     * environment it can use to make decisions. If not, just pass back the
     * value */
    valueOf: function (value) {
      if (_.isFunction(value)) {
        return value(this.view.getEnvironment());
      } else {
        return value;
      }
    },

    createChartObject: function () {
      var c = this.getChartConfig();
   //   console.log(c);
      this.obj = new Highcharts.Chart(c);
      this.obj.chartId = chartCount++;
    },

    render: function (options) {
      options = _.extend(
        {
          animate: true,
        },
        options
      );

      // HC-specific implementation
      this.createChartObject();
      this.plotData(options);
    },
    showLoading: function () {
      this.obj.showLoading();
    },
    destroy: function () {
      if (this.obj) {
        // if (this.view.options.viewInfo.dataSetPath == 'dataSets.earlyEducationAndCare') {

        for (var i = 0; i < charts.length; i++) {
          if (charts[i].chartId == this.obj.chartId) {
            charts.splice(i, 1);
            --count;
          }
        }
        //}

        this.obj.destroy();
      }
    },
  };

  /**
   * @class
   * @classdesc Base class for displaying a chart
   * @augments Backbone.View
   */
  Charts.ChartView = Views.BaseView.extend(
    /** @lends module:cardboard/charts.ChartView.prototype */
    {
      /** reference to a chart provider "class", which will get
       * replaced by an instance of it at runtime */
      chartProvider: Charts.ChartProviders.Highcharts,

      /** the HTML template string we use to construct a chart
       *  wrapper.  this gets replaced by an element maker function
       *  at runtime.
       * @type String */
      wrapperTemplate:
        "<div class='view chartHolder' aria-hidden='true'></div>",

      /** options hash, defaults */
      options: {
        type: "stackedColumn",
        title: "default title",
        legendBackgroundColor: "#FFFFFF",
      },

      globalEvents: {
        beforeWorkspaceStateChange: "onBeforeWorkspaceStateChange",
      },

      /** constructor; initializes the chart provider
       * @param {Object} options options hash */
      initialize: function (options) {
        this.options = options;
        this.options.viewInfo = this.preProcessViewInfo(this.options.viewInfo);
        this.createWrapperElement(options);

        // replace the chartProvider reference with an instance
        this.chartProvider = new this.chartProvider(this);

        if (!this.model) {
          var vi = this.options.viewInfo,
            errMsg =
              "ERROR: no data model on this " +
              vi.type +
              ' chart view. Are you sure the dataSourceName "' +
              this.options.viewInfo.dataSourceName +
              '" is correct?';
          console.log(errMsg);
          throw errMsg;
        }

        // re-render whenever the underlying data model changes
        this.listenTo(this.model, "sync", this.render);
        this.listenTo(this.model, "request", this.maskForLoading);

        // DO NOT render right away. Charts don't render at the
        // correct width if they're rendered into a display:none
        // element, so we need to leave control in the hands of
        // whoever created this view (probably a DataBoxPaneView),
        // so they can be sure that this view's container element
        // is in the DOM and visible before we render.
        // (this.model.isLoaded()) { this.render(); }
      },

      /** destructor! unwire all necessary events, and deallocate
       * other resources as necessary */
      destroy: function () {
        this.stopListening();
        this.undelegateEvents();
        this.chartProvider.destroy();
        this.chartProvider = null;
      },

      /** render the chart; delegates the hard work to the chart provider */
      render: function (modelOrCollection, resp, options) {
        options = _.extend({}, options);

        // if we need to scroll to make the parent pane visible, don't
        // animate the chart. THIS IS A HACK, and won't work all the time.
        if (Util.bottomObscuredByScroll(this.$el.closest(".pane"))) {
          options = _.extend(options, {
            animate: false,
          });
        }

        if (this.model.dataError) {
          return;
        }

        if (this.model.isLoaded()) {
          // why is this here?
          if (this.alreadyRendered()) {
            this.chartProvider.destroy();
          }
          this.applyVisibility();
          this.unmaskForLoading();
          this.chartProvider.render(options);
          this.markRendered();
        } else {
          // EXPERIMENTAL: use the spinner mask rather than the
          // generic progress bar
          this.maskForLoading();
        }
      },

      //
      // INFO METHODS
      //

      getChartableJSON: function () {
        return this.chartProvider.adaptDataForCharting();
      },
      getChartConfig: function () {
        return this.chartProvider.getChartConfig();
      },
      // assemble data needed to make decisions in chart attributes given as
      // functions!
      getEnvironment: function () {
        // so far, all we need is filters, needed by MMR to know how big to
        // make the yAxisMax
        return {
          filters: this.options.dataBoxView.getConfigParams(),
          data: this.model.toJSON(),
        };
      },

      /** return the unit string we need to properly render data
       * point and series labels. Should be given by the plugin in
       * view options object */
      dataUnits: function () {
        // percent is the default units
        var set = this.options.dataUnits;
        return set ? set : "%";
      },

      //
      // EVENT HANDLERS
      //
      onBeforeWorkspaceStateChange: function () {
        // prevents the view from spuriously redrawing itself during a
        // report change
        this.stopListening();
      },
    }
  );

  function seriesHasDataPath(singleSeries) {
    return _(singleSeries).has("dataPath");
  }

  function seriesHasManualValues(singleSeries) {
    return _(singleSeries).has("values");
  }

  return Charts;
});

